import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * WindowMinIcon ~
*/
export default function WindowOptionsIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.852,17.981,3,18V15.945l21.852-.019Z",
    transform: "translate(-2 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4V21H22.853V4.1ZM3,19V6h8V19Zm18,0H13V6h8Z",
    transform: "translate(0 -2)"
  })));
}